import React from "react";
import "../styles/Footer.css";
import { FaPhone, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const NAV_LINKS = ["home", "about", "skills", "projects", "contact"];

const CONTACT_LINKS = [
  { Icon: FaPhone,     label: "Call",      href: "tel:+96181233235" },
  { Icon: FaWhatsapp, label: "WhatsApp",   href: "https://wa.me/96181233235" },
  { Icon: FaEnvelope, label: "Email",      href: "mailto:royzaou14@gmail.com" },
];

const Footer = () => {
  return (
    <footer className="footer">
      {/* top rule */}
      <div className="footer-rule" aria-hidden="true" />

      <div className="footer-container">
        {/* Brand */}
        <div className="footer-brand">
          <a href="#home" className="footer-logo">
            <span className="footer-logo-bracket">[</span>
            <span className="footer-logo-text">RZ</span>
            <span className="footer-logo-bracket">]</span>
          </a>
          <p className="footer-brand-desc">
            Web developer focused on building modern websites and digital
            platforms that help businesses grow online.
          </p>
          <p className="footer-brand-sub">
            Founder of <strong>Codix Tech</strong> & <strong>GoldTech Media</strong>.
            Author of <em>WEB101</em>.
          </p>
        </div>

        {/* Navigation */}
        <div className="footer-col">
          <h4 className="footer-col-title">Navigation</h4>
          <nav className="footer-nav">
            {NAV_LINKS.map((id) => (
              <a key={id} href={`#${id}`} className="footer-link">
                <span className="footer-link-dot" aria-hidden="true" />
                {id.charAt(0).toUpperCase() + id.slice(1)}
              </a>
            ))}
          </nav>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-col-title">Contact</h4>
          <div className="footer-contact-links">
            {CONTACT_LINKS.map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                className="footer-contact-link"
                target={href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
              >
                <span className="footer-contact-icon"><Icon /></span>
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copy">
            © {new Date().getFullYear()} Roy Zaouk. All rights reserved.
          </p>
          <p className="footer-made">
            Crafted with precision &amp; care
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;